import { useSession } from '../../stores/session';

/**
 * The line across the top of every page while a mute is in force.
 *
 * Said once, up here, rather than discovered composer by composer: the
 * person should know before they type a paragraph the server will refuse.
 * The reason is the moderator's own words, verbatim, because a mute with
 * no reason is a punishment nobody can learn from.
 */
export function MutedBanner() {
  const mute = useSession((s) => s.user?.mute ?? null);

  if (mute === null) return null;

  const until = mute.expires_at
    ? `until ${new Date(mute.expires_at).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' })}`
    : 'until a moderator lifts it';

  return (
    <div
      role="status"
      data-muted-banner
      className="border-b border-hot-edge bg-hot-wash px-4 py-2 text-center text-sm text-hot-text"
    >
      <span className="font-medium">You are muted {until}.</span> You can listen, follow and upload,
      but not comment, message, chat or post. Reason: {mute.reason}
    </div>
  );
}
